import { render, staticRenderFns } from "./BusinessRulePendenciesModal.vue?vue&type=template&id=e5caede2&scoped=true&"
import script from "./BusinessRulePendenciesModal.vue?vue&type=script&lang=js&"
export * from "./BusinessRulePendenciesModal.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRulePendenciesModal.vue?vue&type=style&index=0&id=e5caede2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5caede2",
  null
  
)

export default component.exports